import classNames from 'classnames';
import React from 'react';
import type { DistributedOmit } from 'type-fest';
import { IconButton } from '../components/Button';
import * as styles from './GutterButton.module.scss';

const GutterButton = ({
  children,
  className,
  ...props
}: DistributedOmit<React.ComponentProps<typeof IconButton>, 'size'>) => {
  return (
    <IconButton
      className={classNames(styles.button, className)}
      size="md"
      {...props}
    >
      {children}
    </IconButton>
  );
};

export default GutterButton;
